module.exports = __webpack_public_path__ + "static/gallery6-9053e2f83cf51004afbf4878ca500507.jpg";